module.exports = __webpack_public_path__ + "static/media/sustainability-logo.4e85fb81.jpg";